import TrailEndHeader from './TrailEndHeader.js';

export default TrailEndHeader;
